"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContentLoading = exports.LoadingItemContent = exports.getDescendantLeafValues = exports.getAncestorValues = exports.getFocusableValuesAndTreeHeight = exports.filterTree = exports.constructTreeNodeHierarchy = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var ActivitySpinnerWidget_1 = require("../ActivitySpinnerWidget");
var ListItemUtils_1 = require("../List/ListItemUtils");
var constructTreeNodeHierarchy = function (items, unselectableParents, multiselect) {
    var allParentValues = new Set();
    var allParentValuesLoadingWithin = new Set();
    var allSelectableLeafValues = new Set();
    var allSelectableValues = new Set();
    var nodeMapByValue = new Map();
    var topLevelNodes = [];
    items === null || items === void 0 ? void 0 : items.forEach(function (item, index) {
        // separators have no `value` so generate a key in order to place them in the overall hierarchy of nodes
        nodeMapByValue.set(!item.value ? "separator%%" + index : item.value, { children: [], item: item });
        if (isSelectableTreeItem(item)) {
            allSelectableLeafValues.add(item.value);
            allSelectableValues.add(item.value);
        }
    });
    nodeMapByValue.forEach(function (node) {
        if (!node.item.parentValue) {
            topLevelNodes.push(node);
        }
        else {
            var parentNode = nodeMapByValue.get(node.item.parentValue);
            if (parentNode) {
                parentNode.children.push(node);
                allParentValues.add(node.item.parentValue);
                allSelectableLeafValues.delete(node.item.parentValue);
                unselectableParents && allSelectableValues.delete(node.item.parentValue);
                if (exports.isContentLoading(node.item) && multiselect) {
                    exports.getAncestorValues(nodeMapByValue, node.item.value).forEach(function (ancestorValue) {
                        allParentValuesLoadingWithin.add(ancestorValue);
                        allSelectableValues.delete(ancestorValue);
                    });
                }
            }
            else {
                throw new Error("Missing item with value='" + node.item.parentValue + "'. Required because another item has parentValue='" + node.item.parentValue + "'.");
            }
        }
    });
    return { allParentValues: allParentValues, allParentValuesLoadingWithin: allParentValuesLoadingWithin, allSelectableLeafValues: allSelectableLeafValues, allSelectableValues: allSelectableValues, nodeMapByValue: nodeMapByValue, topLevelNodes: topLevelNodes };
};
exports.constructTreeNodeHierarchy = constructTreeNodeHierarchy;
/**
 * @returns whether a tree item is selectable, taking into account whether it has content loading
 */
var isSelectableTreeItem = function (item) {
    return ListItemUtils_1.isSelectableItem(item) && !exports.isContentLoading(item);
};
/**
 * @returns
 * `matchedValues` - a set of values associated with nodes that match the passed in `searchText` determined using `filterFn`
 *
 * `matchedValuesAncestors` - a set of values associated with ancestors of matched nodes
 *
 * `topLevelNodesFiltered` - a copy of the passed in `topLevelNodes` with unmatched branches taken out and with special treatment for group or separator nodes
 */
var filterTree = function (topLevelNodes, searchText, filterFn) {
    if (filterFn === void 0) { filterFn = ListItemUtils_1.caseInsensitiveValueMatch; }
    var matchedValues = new Set();
    var matchedValuesAncestors = new Set();
    if (!searchText) {
        return { matchedValues: matchedValues, matchedValuesAncestors: matchedValuesAncestors, topLevelNodesFiltered: topLevelNodes };
    }
    var topLevelNodesFiltered = new Array();
    var currentNodeByLevel = new Array();
    var groupOrSeparatorNodeByLevel = new Array();
    traverseTree(topLevelNodes, function (node, level) {
        currentNodeByLevel[level] = { item: node.item, children: [] };
        if (node.item.group || node.item.separator) {
            groupOrSeparatorNodeByLevel[level] = node;
        }
        else if (filterFn(node.item, searchText)) {
            node.item.value && matchedValues.add(node.item.value);
            for (var i = 0; i < level; i++) {
                var ancestorValue = currentNodeByLevel[i].item.value;
                ancestorValue && matchedValuesAncestors.add(ancestorValue);
            }
        }
    }, function () { return true; }, 0, function (node, level) {
        if (!node.item.value) {
            return;
        }
        var placeToInsert = level > 0 ? currentNodeByLevel[level - 1].children : topLevelNodesFiltered;
        var isMatch = matchedValues.has(node.item.value);
        if (isMatch) {
            currentNodeByLevel[level].children = node.children;
        }
        if (isMatch || matchedValuesAncestors.has(node.item.value)) {
            var groupOrSeparatorNode = groupOrSeparatorNodeByLevel[level];
            if (groupOrSeparatorNode) {
                groupOrSeparatorNodeByLevel[level] = undefined;
                if (placeToInsert.length || !groupOrSeparatorNode.item.separator) {
                    placeToInsert.push(groupOrSeparatorNode);
                }
            }
            placeToInsert.push(currentNodeByLevel[level]);
        }
    });
    return { matchedValues: matchedValues, matchedValuesAncestors: matchedValuesAncestors, topLevelNodesFiltered: topLevelNodesFiltered };
};
exports.filterTree = filterTree;
/**
 * @returns
 * `focusableValues` - an array of values associated with focusable nodes, excluding any nodes that would not be shown because their parents are not expanded
 *
 * `treeHeight` - the number of levels on the longest path from a top level node to a leaf node
 */
var getFocusableValuesAndTreeHeight = function (topLevelNodes, expandedValues) {
    var focusableValues = [];
    var treeHeight = 0;
    traverseTree(topLevelNodes, function (node, level) {
        ListItemUtils_1.isFocusableItem(node.item) && focusableValues.push(node.item.value);
        if (typeof level === 'number') {
            treeHeight = Math.max(treeHeight, level);
        }
    }, function (node) { return expandedValues.has(node.item.value); }, 0);
    return { focusableValues: focusableValues, treeHeight: treeHeight };
};
exports.getFocusableValuesAndTreeHeight = getFocusableValuesAndTreeHeight;
/**
 * @returns an array of values associated with ancestor nodes of the node with the given value
 */
var getAncestorValues = function (nodeMapByValue, value) {
    var ancestorValues = [];
    var currentNode = nodeMapByValue.get(value);
    while (currentNode && currentNode.item.parentValue) {
        ancestorValues.push(currentNode.item.parentValue);
        currentNode = nodeMapByValue.get(currentNode.item.parentValue);
    }
    return ancestorValues;
};
exports.getAncestorValues = getAncestorValues;
/**
 * @returns an array of values associated with descendant leaf nodes of the node with the given value
 */
var getDescendantLeafValues = function (nodeMapByValue, value) {
    var descendantLeafValues = [];
    var currentNode = nodeMapByValue.get(value);
    if (currentNode && currentNode.children.length) {
        traverseTree(currentNode.children, function (node) {
            if (node.item.value && !node.item.group && !node.item.separator && !node.children.length) {
                descendantLeafValues.push(node.item.value);
            }
        }, function () { return true; });
    }
    return descendantLeafValues;
};
exports.getDescendantLeafValues = getDescendantLeafValues;
var traverseTree = function (nodes, performAction, shouldIncludeChildren, level, performActionAfter) {
    nodes.forEach(function (node) {
        performAction(node, level);
        if (shouldIncludeChildren(node)) {
            traverseTree(node.children, performAction, shouldIncludeChildren, typeof level === 'number' ? level + 1 : level, performActionAfter);
        }
        performActionAfter === null || performActionAfter === void 0 ? void 0 : performActionAfter(node, level);
    });
};
/** A special component that can be passed as `TreeItem.content` to indicate the item is loading while meeting accessibility standards */
var LoadingItemContent = function (props) {
    return React.createElement(ActivitySpinnerWidget_1.ActivitySpinnerWidget, tslib_1.__assign({}, props, { alt: Localize_1.Messages.loading(), spinnerSize: ActivitySpinnerWidget_1.ActivitySpinnerSize.Small }));
};
exports.LoadingItemContent = LoadingItemContent;
exports.LoadingItemContent.displayName = 'LoadingItemContent';
var isContentLoading = function (item) { return React.isValidElement(item.content) && item.content.type === exports.LoadingItemContent; };
exports.isContentLoading = isContentLoading;
//# sourceMappingURL=TreeHelpers.js.map